<div class="corporate-material-item clickable" *ngIf="isDisplay">
  <div class="icon {{fileType}}"></div>
  <div class="info">
    <div class="name text-color-primary">{{material.name}}</div>
    <div class="desc text-color-secondary">{{material.description}}</div>
  </div>
</div>